module.exports = __webpack_public_path__ + "static/media/dinesh.be6c1c81.png";